import { render, staticRenderFns } from "./SouthEden.vue?vue&type=template&id=3fba4bb0&scoped=true&"
import script from "./SouthEden.vue?vue&type=script&lang=js&"
export * from "./SouthEden.vue?vue&type=script&lang=js&"
import style0 from "./SouthEden.vue?vue&type=style&index=0&id=3fba4bb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba4bb0",
  null
  
)

export default component.exports